import {
  LABORDENDIGITAL_GETPDF_ERROR,
  LABORDENDIGITAL_GETPDF_LOADING,
  LABORDENDIGITAL_GETPDF_RESET,
  LABORDENDIGITAL_GETPDF_SUCCESS,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";

import pdfOrdenDigitalInitialState from "../initialStates/pdfOrdenDigitalInitialState";

const pdfOrdenDigital = (state, { payload, type }) => {
  switch (type) {
    case LABORDENDIGITAL_GETPDF_LOADING:
      return {
        ...state,
        pdfOrdenDigital: {
          ...state.pdfOrdenDigital,
          error: false,
          loading: true,
        },
      };
    case LABORDENDIGITAL_GETPDF_SUCCESS:
      return {
        ...state,
        pdfOrdenDigital: {
          ...state.pdfOrdenDigital,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case LABORDENDIGITAL_GETPDF_ERROR:
      return {
        ...state,
        pdfOrdenDigital: {
          ...state.pdfOrdenDigital,
          error: payload,
          loading: false,
        },
      };

    case LABORDENDIGITAL_GETPDF_RESET:
      return pdfOrdenDigitalInitialState;
    case RESET_PORTAL_CONTEXT:
      return pdfOrdenDigitalInitialState;

    default:
      return state;
  }
};

export default pdfOrdenDigital;
